<template>
  <div v-if="showInStock">
  <VcChip v-if="isDigital" :size="size" variant="outline-dark" color="info" rounded>
    <VcIcon name="cloud" />

    {{ $t("common.labels.digital_product") }}
  </VcChip>

  <VcChip
    v-else-if="isInStock"
    :size="size"
    variant="outline-dark"
    color="success"
    rounded
    :title="$t('common.labels.in_stock')"
  >
    <VcIcon name="cube" />

    <span class="inline-block min-w-3 text-center">
      {{ quantity ? inStockQuantityLabel : $t("common.labels.in_stock") }}
    </span>
  </VcChip>

  <VcChip
    v-else
    :size="size"
    variant="outline-dark"
    color="danger"
    rounded
    :title="
      !isAvailable ? $t('common.messages.product_no_longer_available') : $t('common.messages.product_out_of_stock')
    "
  >
    <VcIcon name="cube" />

    <span class="inline-block min-w-3 text-center">0</span>
  </VcChip>
</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { MAX_DISPLAY_IN_STOCK_QUANTITY } from "@/core/constants";

interface IProps {
  isInStock?: boolean;
  isAvailable?: boolean;
  isDigital?: boolean;
  quantity?: number | null;
  size?: VcChipSizeType;
  textEnabled?: boolean;
}

// Global flag to control the visibility of InStock
const showInStock = computed(() => {
  return false;  // Change to `false` to hide it globally
});

const props = withDefaults(defineProps<IProps>(), {
  isAvailable: true,
  quantity: null,
  size: "sm",
  textEnabled: true,
});

const inStockQuantityLabel = computed<string>(() =>
  props.quantity && props.quantity > MAX_DISPLAY_IN_STOCK_QUANTITY
    ? `${MAX_DISPLAY_IN_STOCK_QUANTITY}+`
    : props.quantity!.toString(),
);
</script>
